import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {calendariodata, calendariodataescuela} from '../../utils';
import Card from '../../components/ui/card'
import Cardescuela from '../../components/ui/cardescuela'
import { Link } from "react-router-dom";

export default function Calendario() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [data1, data2] = await Promise.all([
          calendariodata('home'),
          calendariodataescuela()
        ]);
        const combinedData = [...data1, ...data2];
        combinedData.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
        setData(combinedData);
      } catch (error) {
        console.error("Error fetching calendar data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <div></div>;
  }

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              dots: true,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              dots: false,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
            }
          }
        ]
      };

  return (
    <div className="calendario">
        <h4 className='title-ico'><i></i><span>Galería de encuentros</span></h4> 
        <Link to='/encuentros' className='btn-verde'>Ver todos</Link>
        <div className="cards">
            <Slider {...settings}>
              {data.map((item) =>
                item.escuela ? <Cardescuela key={item.id} data={item} /> : <Card key={item.id} data={item} />
              )}
            </Slider>
          </div>
    </div>
  );
}